import React, { useEffect, useState } from "react";
import { scheduledJobs } from "../../libs/dashboard";
import {
  buildReportFetchParams,
  refetchReportWithoutSearch,
  resetReportFilters,
} from "../../libs/reportFetchHelpers";
import { loggedInUsers } from "../../store/store";
import DataTable from "react-data-table-component";
import { formatNumber } from "../../libs/helper";
import ReportToolbar from "../../components/ReportToolbar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";

var CryptoJS = require("crypto-js");

const columns = [
  {
    name: "Id",
    selector: (row) => row.batchId,
  },
  {
    name: "scheduled Time",
    selector: (row) => row.scheduleDateTime,
    sortable: true,
  },
  {
    name: "Status",
    selector: (row) => row.status,
    sortable: true,
  },
  {
    name: "Created At",
    selector: (row) => row.createdAt,
    sortable: true,
  },
];

const ScheduledReport = () => {
  const { userdata } = loggedInUsers((state) => state.auth);
  var getUser = CryptoJS.AES.decrypt(
    userdata,
    process.env.REACT_APP_SOCKET_ENCRYPTION_KEY
  );
  var userD = JSON.parse(getUser.toString(CryptoJS.enc.Utf8));

  const todayDateString = dayjs().format("YYYY-MM-DD");

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [filterDate, setFilterDate] = useState([
    todayDateString,
    todayDateString,
  ]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async (Fetch_values) => {
    setLoading(true);

    const emailToUse =
      userD?.userType === "user-group" ? userD?.orgEmail : userD?.email;

    Fetch_values = Object.assign(Fetch_values, {
      email: emailToUse,
      bearerToken: userD?.bearerToken,
    });

    try {
      const getRec = await scheduledJobs(Fetch_values);

      if (getRec) {
        setIsLoaded(true);
        setLoading(false);
        setItems(getRec.data);
        setTotalRows(getRec.headers["x-pagination-totalcount"]);
      } else {
        setIsLoaded(true);
        setError("No data returned");
      }
    } catch (err) {
      setIsLoaded(true);
      setError(err);
    }
  };

  const loadReport = (overrides = {}) => {
    fetchData(
      buildReportFetchParams({
        perPage,
        filterDate,
        searchTerm,
        overrides,
      })
    );
  };

  useEffect(() => {
    loadReport({ page: 1 });
  }, [perPage]);

  const onDateChange = (value, dateString) => {
    if (value) {
      setFilterDate(dateString);
      fetchData(
        buildReportFetchParams({
          page: 1,
          perPage,
          filterDate: dateString,
          searchTerm,
        })
      );
    } else {
      setFilterDate(null);
      fetchData(
        buildReportFetchParams({
          page: 1,
          perPage,
          filterDate: null,
          searchTerm,
        })
      );
    }
  };

  const handlePageChange = (page) => {
    loadReport({ page });
  };

  const handlePerRowsChange = async (newPerPage) => {
    setPerPage(newPerPage);
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (!value) {
      refetchReportWithoutSearch({ filterDate, perPage, fetchData });
    }
  };

  const handleSubmitSearch = () => {
    loadReport({ page: 1 });
  };

  const handleKeypress = (e) => {
    if (e.keyCode === 13) {
      if (e.target.value?.trim()) {
        handleSubmitSearch();
      } else {
        setSearchTerm("");
        refetchReportWithoutSearch({ filterDate, perPage, fetchData });
      }
    }
  };

  const handleResetFilters = () => {
    resetReportFilters({
      todayDateString,
      perPage,
      setSearchTerm,
      setFilterDate,
      fetchData,
    });
  };

  const dataRowStyles = {
    color: loading ? "gray" : "black",
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return <div>Loading...</div>;
  } else {
    return (
      <div className="App">
        <h1 className="text-xl font-semibold">
          Scheduled SMS Transaction History
        </h1>
        <p className="text-xs font-semibold mb-2">
          <span className="text-xl font-semibold">
            {formatNumber(totalRows)}
          </span>{" "}
          Records Found
        </p>
        <ReportToolbar
          filterDate={filterDate}
          onDateChange={onDateChange}
          searchTerm={searchTerm}
          searchInputValue={searchTerm}
          onSearchChange={handleSearchChange}
          onSearchKeyDown={handleKeypress}
          onSubmitSearch={handleSubmitSearch}
          onResetFilters={handleResetFilters}
        />
        <DataTable
          columns={columns}
          data={items}
          fixedHeader
          pagination
          highlightOnHover="true"
          paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 50, 100]}
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          customStyles={{
            rows: {
              style: dataRowStyles,
            },
          }}
        />
        <ToastContainer autoClose={3000} theme="colored" newestOnTop={true} />
      </div>
    );
  }
};

export default ScheduledReport;
